import React from "react";
import { extendTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import logo from "../../Assets/STAY-logo.png";

export const demoTheme = extendTheme({
  colorSchemes: { light: true, dark: true },
  colorSchemeSelector: "class",
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ".css-14tatqh-MuiTypography-root": {
          display: "none !important",
        },
        ".css-yzjoij": {
          display: "none !important",
        },
        ".css-f84ov1-MuiTypography-root": {
          display: "none !important",
        },
        ".css-23htwk": {
          background: "#f5f5f5",
        },
      },
    },
  },
});

export const CustomAppTitle = () => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Tooltip title="Connected to production">
        <CheckCircleIcon color="success" fontSize="small" />
      </Tooltip>
    </Stack>
  );
};

export const SidebarFooter = ({ mini }) => {
  return (
    <Typography
      variant="caption"
      sx={{ m: 1, whiteSpace: "nowrap", overflow: "hidden" }}
    >
      {mini ? "© WebTronic" : `© WebTronic ${new Date().getFullYear()}`}
    </Typography>
  );
};

SidebarFooter.propTypes = {
  mini: PropTypes.bool.isRequired,
};

export const useDemoRouter = (initialPath) => {
  const [pathname, setPathname] = React.useState(initialPath);

  const router = React.useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => setPathname(String(path)),
    };
  }, [pathname]);

  return router;
};
